module.exports = __webpack_public_path__ + "media/apps/gif-android-5-ed7040a7.gif";